import React from 'react';
import { Helmet } from 'react-helmet';

export default function SEO({ title, description, schemaData }) {
  const siteUrl = "https://driver.org.il";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "דרייבר.ישראל",
    "alternateName": "Driver Israel - משלוחים בקהילה",
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "description": "פלטפורמת המשלוחים הקהילתית של ישראל. מחברים בין שולחי חבילות לשליחים באזור.",
    "address": { "@type": "PostalAddress", "addressCountry": "IL" },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "areaServed": "IL",
      "availableLanguage": "Hebrew",
    },
  };

  return (
    <Helmet>
      <title>{title ? `${title} | דרייבר.ישראל` : 'דרייבר.ישראל - משלוחים מהירים בקהילה'}</title>
      <meta name="description" content={description || "שלח חבילה או הרווח כשליח. פלטפורמת המשלוחים הקהילתית של ישראל."} />
      <link rel="canonical" href={siteUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={title || "דרייבר.ישראל - משלוחים בקהילה"} />
      <meta property="og:description" content={description || "פלטפורמת המשלוחים הקהילתית של ישראל."} />
      <meta property="og:image" content={`${siteUrl}/og-image.jpg`} />

      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      {schemaData && <script type="application/ld+json">{JSON.stringify(schemaData)}</script>}
    </Helmet>
  );
}
